﻿/* ══════════════════════════════════════════════
   MAISON BOURGEOIS PARIS — SHOPIFY THEME JS v2
   OS 2.0 — bourgeoisparis.com
   ══════════════════════════════════════════════ */
'use strict';

function ready(fn) {
  if (document.readyState !== 'loading') fn();
  else document.addEventListener('DOMContentLoaded', fn);
}

ready(function () {

  /* Back to Top */
  var btt = document.getElementById('backToTop');
  if (btt) {
    var bttTicking = false;
    window.addEventListener('scroll', function () {
      if (bttTicking) return;
      bttTicking = true;
      window.requestAnimationFrame(function () {
        if (window.scrollY > 400) btt.removeAttribute('hidden');
        else btt.setAttribute('hidden', '');
        bttTicking = false;
      });
    }, { passive: true });
    btt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* Mobile Menu */
  var menuBtn = document.getElementById('mobileMenuBtn');
  var drawer  = document.getElementById('mobileNavDrawer');
  var overlay = document.getElementById('mobileNavOverlay');
  var closeBtn = document.getElementById('mobileNavClose');

  function openNav() {
    if (!drawer) return;
    drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.classList.add('open'); }
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (!drawer) return;
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
    if (overlay) { overlay.classList.remove('open'); }
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (menuBtn)  menuBtn.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (overlay)  overlay.addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });

  /* Wishlist — persistent localStorage */
  (function () {
    var KEY = 'mb_wishlist_v1';

    function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e) { return []; } }
    function save(list) { localStorage.setItem(KEY, JSON.stringify(list)); }
    function isLiked(id) { return get().some(function(p){ return p.id == id; }); }

    function add(p) {
      var list = get();
      if (!list.some(function(x){ return x.id == p.id; })) { list.unshift(p); save(list); }
    }
    function remove(id) { save(get().filter(function(p){ return p.id != id; })); }

    function setState(btn, liked) {
      btn.setAttribute('aria-pressed', String(liked));
      btn.classList.toggle('active', liked);
      var svg = btn.querySelector('svg');
      if (svg) svg.style.fill = liked ? 'currentColor' : 'none';
    }

    function renderDrawer() {
      var section = document.getElementById('wishlist-drawer-section');
      if (!section) return;
      var list = get();
      section.style.display = list.length ? '' : 'none';
      var ul = document.getElementById('wishlist-drawer-items');
      if (!ul) return;
      ul.innerHTML = list.map(function(p) {
        return '<li class="wishlist-drawer__item" data-id="' + p.id + '">' +
          '<a href="' + p.url + '" class="wishlist-drawer__img">' +
            (p.image ? '<img src="' + p.image + '" alt="" width="56" height="70" loading="lazy"/>' : '<div class="wishlist-drawer__img-ph"></div>') +
          '</a>' +
          '<div class="wishlist-drawer__info">' +
            '<a href="' + p.url + '" class="wishlist-drawer__name">' + p.title + '</a>' +
            (p.volume ? '<p class="wishlist-drawer__vol">' + p.volume + '</p>' : '') +
            '<p class="wishlist-drawer__price">' + p.price + '</p>' +
            '<div class="wishlist-drawer__row">' +
              (p.variantId ? '<button type="button" class="wishlist-drawer__add" data-variant="' + p.variantId + '" data-volume="' + (p.volume || '') + '">' + window.MB_I18N.addToCart + '</button>' : '') +
              '<button type="button" class="wishlist-drawer__del" data-id="' + p.id + '" aria-label="' + window.MB_I18N.removeFav + '">' +
                '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</li>';
      }).join('');

      ul.querySelectorAll('.wishlist-drawer__del').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var id = this.dataset.id;
          remove(id);
          var heart = document.querySelector('.wishlist-btn[data-product-id="' + id + '"]');
          if (heart) setState(heart, false);
          renderDrawer();
        });
      });

      ul.querySelectorAll('.wishlist-drawer__add').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var variantId = this.dataset.variant;
          var vol = this.dataset.volume;
          var self = this;
          self.textContent = '…';
          self.disabled = true;
          var payload = {id: variantId, quantity: 1};
          if (vol) payload.properties = {_volume: vol};
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(payload)
          })
          .then(function(r){ return r.json(); })
          .then(function() {
            /* L'article BASCULE des favoris vers le panier : on le retire des favoris
               (coeur desactive sur la page + liste favoris re-rendue sans lui). */
            var li = self.closest('.wishlist-drawer__item');
            var pid = li ? li.dataset.id : null;
            if (pid) {
              remove(pid);
              var heart = document.querySelector('.wishlist-btn[data-product-id="' + pid + '"]');
              if (heart) setState(heart, false);
            }
            /* Rafraichit le panier complet instantanement : badges (desktop + mobile)
               + contenu du tiroir ; la section favoris est re-rendue sans cet article. */
            if (window.openCartDrawer) {
              window.openCartDrawer();
            } else {
              renderDrawer();
              fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
                document.querySelectorAll('#cart-count, .cart-badge').forEach(function(el){
                  el.textContent = cart.item_count;
                  el.classList.toggle('cart-badge--hidden', cart.item_count === 0);
                });
              });
            }
          })
          .catch(function(){ self.textContent = window.MB_I18N.addToCart; self.disabled = false; });
        });
      });
    }

    // Init hearts on page load
    document.querySelectorAll('.wishlist-btn').forEach(function(btn) {
      setState(btn, isLiked(btn.dataset.productId));
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        var id = this.dataset.productId;
        if (isLiked(id)) {
          remove(id);
          setState(this, false);
        } else {
          add({
            id: id,
            title: this.dataset.productTitle || '',
            url: this.dataset.productUrl || '#',
            price: this.dataset.productPrice || '',
            image: this.dataset.productImage || '',
            variantId: this.dataset.variantId || '',
            volume: this.dataset.productVolume || ''
          });
          setState(this, true);
        }
        renderDrawer();
      });
    });

    renderDrawer();
    window.renderWishlistDrawer = renderDrawer;
  })();

  /* Product gallery thumbs + arrows */
  var slides = document.querySelectorAll('.product-gallery-slide');
  var thumbs = document.querySelectorAll('.product-thumb');

  function goToSlide(n) {
    var cur = Array.from(slides).findIndex(function(s) { return s.classList.contains('active'); });
    var next = (cur + n + slides.length) % slides.length;
    slides.forEach(function(s) { s.classList.remove('active'); });
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    if (slides[next]) slides[next].classList.add('active');
    if (thumbs[next]) thumbs[next].classList.add('active');
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = parseInt(this.dataset.index, 10);
      slides.forEach(function (s) { s.classList.remove('active'); });
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      if (slides[idx]) slides[idx].classList.add('active');
      this.classList.add('active');
    });
  });

  var prevBtn = document.querySelector('.gallery-arrow--prev');
  var nextBtn = document.querySelector('.gallery-arrow--next');
  if (prevBtn) prevBtn.addEventListener('click', function() { goToSlide(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goToSlide(1); });

  /* Variant selector */
  var variantInput = document.getElementById('productVariantId');
  var optionBtns = document.querySelectorAll('.product-option-btn');
  if (optionBtns.length && typeof productVariants !== 'undefined' && productVariants.length) {
    var selected = productVariants[0].options.slice();
    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optIdx = parseInt(this.dataset.optionIndex, 10);
        selected[optIdx] = this.dataset.value;
        document.querySelectorAll('.product-option-btn[data-option-index="' + optIdx + '"]').forEach(function (b) {
          b.classList.remove('selected');
        });
        this.classList.add('selected');

        var match = productVariants.find(function (v) {
          return v.options.every(function (o, j) { return o === selected[j]; });
        });
        if (!match) return;

        if (variantInput) variantInput.value = match.id;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}

        var priceEl = document.querySelector('.product-price-current');
        var compareEl = document.querySelector('.product-price-compare');
        if (priceEl) {
          priceEl.textContent = formatMoney(match.price);
          priceEl.classList.toggle('on-sale', match.compare_at_price > match.price);
        }
        if (compareEl) {
          compareEl.style.display = match.compare_at_price > match.price ? '' : 'none';
          if (match.compare_at_price > match.price) compareEl.innerHTML = '<s>' + formatMoney(match.compare_at_price) + '</s>';
        }

        var addBtn = document.getElementById('addToCartBtn');
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.style.background = match.available ? '' : 'var(--grey)';
          addBtn.textContent = match.available ? 'Ajouter au Panier' : 'Produit Épuisé';
        }
      });
    });
  }

  /* Qty selectors */
  function initQty(minusId, plusId, inputId, hiddenId) {
    var minus = document.getElementById(minusId);
    var plus  = document.getElementById(plusId);
    var input = document.getElementById(inputId);
    var hidden = document.getElementById(hiddenId);
    if (!minus || !plus || !input) return;
    function sync() { if (hidden) hidden.value = input.value; }
    minus.addEventListener('click', function () { input.value = Math.max(1, parseInt(input.value, 10) - 1); sync(); });
    plus.addEventListener('click', function ()  { input.value = parseInt(input.value, 10) + 1; sync(); });
    input.addEventListener('change', sync);
  }
  initQty('qtyMinus', 'qtyPlus', 'productQty', 'productQtyHidden');

  document.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var inp = document.querySelector('.qty-input[data-line="' + this.dataset.line + '"]');
      if (!inp) return;
      var v = parseInt(inp.value, 10) || 0;
      inp.value = this.dataset.action === 'minus' ? Math.max(0, v - 1) : v + 1;
    });
  });

  /* AJAX Add to Cart — product form */
  var pForm = document.getElementById('ProductForm');
  if (pForm) {
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = this.querySelector('button[type="submit"]');
      var orig = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Ajout…'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(this) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status) alert(d.description || 'Erreur');
          else { refreshCartCount(); if (window.openCartDrawer) window.openCartDrawer(); else showCartNotif(); }
        })
        .catch(function () { alert('Erreur réseau. Réessayez.'); })
        .finally(function () { if (addBtn) { addBtn.disabled = false; addBtn.textContent = orig; } });
    });
  }

  /* AJAX Add to Cart — quick add cards */
  document.querySelectorAll('.product-cta[data-variant-id]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var vid = this.dataset.variantId;
      if (!vid) return;
      var vol = this.dataset.volume;
      var payload = { id: parseInt(vid, 10), quantity: 1 };
      if (vol) payload.properties = { _volume: vol };
      var orig = this.textContent;
      this.disabled = true; this.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (!d.status) { refreshCartCount(); if (window.openCartDrawer) window.openCartDrawer(); else showCartNotif(); } })
      .catch(function () {})
      .finally(function () { btn.disabled = false; btn.textContent = orig; });
    });
  });

  /* Cart notification */
  function showCartNotif() {
    var n = document.getElementById('cart-notification');
    if (!n) return;
    n.setAttribute('aria-hidden', 'false');
    clearTimeout(n._t);
    n._t = setTimeout(function () { n.setAttribute('aria-hidden', 'true'); }, 3500);
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('#cart-count, .cart-badge').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('cart-badge--hidden', cart.item_count === 0);
        });
      });
  }

  /* Accordions */
  document.querySelectorAll('.accordion-header').forEach(function (h) {
    var item = h.closest('.accordion-item');
    var body = item ? item.querySelector('.accordion-body') : null;
    if (item && item.classList.contains('active') && body) {
      body.removeAttribute('hidden'); body.style.display = 'block';
      h.setAttribute('aria-expanded', 'true');
    }
    h.addEventListener('click', function () {
      var isOpen = item.classList.contains('active');
      document.querySelectorAll('.accordion-item').forEach(function (i) {
        i.classList.remove('active');
        var b = i.querySelector('.accordion-body'), hh = i.querySelector('.accordion-header');
        if (b) { b.style.display = 'none'; }
        if (hh) hh.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen && body) {
        item.classList.add('active');
        body.style.display = 'block';
        h.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Money formatter */
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
  }

});



/* -- Account Drawer -------------------------------------------------------- */
(function () {
  var SF_TOKEN = '5bededf55a9d091c73e4150e65ac76df';
  var SF_URL   = '/api/2024-01/graphql.json';

  var drawer   = document.getElementById('account-drawer');
  if (!drawer) return;

  var openBtns  = document.querySelectorAll('.js-account-drawer-open');
  var closeBtns = document.querySelectorAll('.js-account-drawer-close');
  var tabs      = drawer.querySelectorAll('[data-drawer-tab]');
  var alertBox  = document.getElementById('drawerAlert');

  function openDrawer(tab) {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    openBtns.forEach(function(b){ b.setAttribute('aria-expanded','true'); });
    if (tab) switchTab(tab);
    if (alertBox) hideAlert();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    openBtns.forEach(function(b){ b.setAttribute('aria-expanded','false'); });
  }

  function switchTab(name) {
    tabs.forEach(function(t){
      t.classList.toggle('account-drawer__tab--active', t.dataset.drawerTab === name);
      t.setAttribute('aria-selected', t.dataset.drawerTab === name ? 'true' : 'false');
    });
    drawer.querySelectorAll('.account-drawer__form').forEach(function(f){
      f.classList.toggle('account-drawer__form--hidden', f.id !== 'drawer-panel-' + name);
    });
    if (alertBox) hideAlert();
  }

  function showAlert(msg, type) {
    if (!alertBox) return;
    alertBox.textContent = msg;
    alertBox.className = 'account-drawer__alert account-drawer__alert--' + type;
    alertBox.style.display = 'block';
  }

  function hideAlert() { if (alertBox) alertBox.style.display = 'none'; }

  function setLoading(btn, loading) {
    btn.disabled = loading;
    var label  = btn.querySelector('.btn-label');
    var loader = btn.querySelector('.btn-loader');
    if (label)  label.style.display  = loading ? 'none' : '';
    if (loader) loader.style.display = loading ? 'flex' : 'none';
  }

  function sfFetch(query, variables) {
    return fetch(SF_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function(r){ return r.json(); });
  }

  function doServerLogin(email, password) {
    var fd = new FormData();
    fd.append('customer[email]', email);
    fd.append('customer[password]', password);
    fd.append('return_to', '/account');
    return fetch('/account/login', { method: 'POST', body: fd, redirect: 'follow' })
      .then(function(){ window.location.href = '/account'; });
  }

  var loginBtn = document.getElementById('drawerLoginBtn');
  if (loginBtn) {
    loginBtn.addEventListener('click', function () {
      var self = this;
      var email = document.getElementById('drawer-login-email').value.trim();
      var password = document.getElementById('drawer-login-password').value;
      if (!email || !password) { showAlert('Veuillez remplir tous les champs.', 'error'); return; }
      setLoading(self, true); hideAlert();
      sfFetch(
        'mutation login($i:CustomerAccessTokenCreateInput!){customerAccessTokenCreate(input:$i){customerAccessToken{accessToken}customerUserErrors{message}}}',
        { i: { email: email, password: password } }
      ).then(function(data) {
        var errs = data && data.data && data.data.customerAccessTokenCreate && data.data.customerAccessTokenCreate.customerUserErrors;
        if (errs && errs.length > 0) { setLoading(self, false); showAlert('Identifiants incorrects.', 'error'); return; }
        return doServerLogin(email, password);
      }).catch(function(){ setLoading(self, false); showAlert('Une erreur est survenue.', 'error'); });
    });
  }

  var registerBtn = document.getElementById('drawerRegisterBtn');
  if (registerBtn) {
    registerBtn.addEventListener('click', function () {
      var self = this;
      var firstName = document.getElementById('drawer-reg-firstname').value.trim();
      var lastName  = document.getElementById('drawer-reg-lastname').value.trim();
      var email     = document.getElementById('drawer-reg-email').value.trim();
      var password  = document.getElementById('drawer-reg-password').value;
      if (!firstName || !lastName || !email || !password) { showAlert('Veuillez remplir tous les champs.', 'error'); return; }
      setLoading(self, true); hideAlert();
      sfFetch(
        'mutation reg($i:CustomerCreateInput!){customerCreate(input:$i){customer{id}customerUserErrors{message field}}}',
        { i: { firstName: firstName, lastName: lastName, email: email, password: password } }
      ).then(function(data) {
        var errs = data && data.data && data.data.customerCreate && data.data.customerCreate.customerUserErrors;
        if (errs && errs.length > 0) { setLoading(self, false); showAlert(errs[0].message, 'error'); return; }
        return doServerLogin(email, password);
      }).catch(function(){ setLoading(self, false); showAlert('Une erreur est survenue.', 'error'); });
    });
  }

  var forgotBtn = document.getElementById('drawerForgotBtn');
  if (forgotBtn) {
    forgotBtn.addEventListener('click', function () {
      tabs.forEach(function(t){ t.classList.remove('account-drawer__tab--active'); });
      drawer.querySelectorAll('.account-drawer__form').forEach(function(f){ f.classList.add('account-drawer__form--hidden'); });
      var fp = document.getElementById('drawer-panel-forgot');
      if (fp) fp.classList.remove('account-drawer__form--hidden');
      hideAlert();
    });
  }

  var backBtn = document.getElementById('drawerBackBtn');
  if (backBtn) backBtn.addEventListener('click', function () { switchTab('login'); });

  var recoverBtn = document.getElementById('drawerRecoverBtn');
  if (recoverBtn) {
    recoverBtn.addEventListener('click', function () {
      var self = this;
      var emailEl = document.getElementById('drawer-recover-email');
      var email = emailEl ? emailEl.value.trim() : '';
      if (!email) { showAlert('Veuillez saisir votre adresse e-mail.', 'error'); return; }
      setLoading(self, true); hideAlert();
      var fd = new FormData();
      fd.append('customer[email]', email);
      fetch('/account/recover', { method: 'POST', body: fd }).then(function(){
        setLoading(self, false);
        showAlert('E-mail de reinitialisation envoye.', 'success');
        setTimeout(function(){ switchTab('login'); }, 3000);
      });
    });
  }

  openBtns.forEach(function(btn){
    btn.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); });
  });
  closeBtns.forEach(function(btn){ btn.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){ switchTab(this.dataset.drawerTab); });
  });
  drawer.querySelectorAll('.account-drawer__input').forEach(function(input){
    input.addEventListener('keydown', function(e){
      if (e.key !== 'Enter') return;
      var form = input.closest('.account-drawer__form');
      if (!form) return;
      var btn = form.querySelector('.account-drawer__submit');
      if (btn) btn.click();
    });
  });
})();

/* -- Cart Drawer ------------------------------------------------------------ */
ready(function () {
(function () {
  var cartDrawer = document.getElementById('cart-drawer');
  if (!cartDrawer) return;

  var cartBody = cartDrawer.querySelector('.cart-drawer__body');
  var cartFoot = cartDrawer.querySelector('.cart-drawer__foot');

  function fmt(cents) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function openCartDrawer() {
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('.js-cart-drawer-open').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    fetchAndRender();
  }

  function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.querySelectorAll('.js-cart-drawer-open').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  window.openCartDrawer = openCartDrawer;

  /* Triggers */
  document.querySelectorAll('.js-cart-drawer-open').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
  });

  cartDrawer.addEventListener('click', function (e) {
    if (e.target.classList.contains('cart-drawer__overlay') || e.target.classList.contains('js-cart-drawer-close')) {
      closeCartDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCartDrawer();
  });

  /* Fetch + Render */
  function fetchAndRender() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }

  function injectWishlistSection() {
    if (document.getElementById('wishlist-drawer-section')) return;
    var wlSection = document.createElement('div');
    wlSection.id = 'wishlist-drawer-section';
    wlSection.className = 'wishlist-drawer-section';
    wlSection.style.display = 'none';
    wlSection.setAttribute('aria-label', 'Vos favoris');
    wlSection.innerHTML =
      '<div class="wishlist-drawer__head">' +
      '<svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
      ' ' + window.MB_I18N.favorites + '</div>' +
      '<ul id="wishlist-drawer-items" class="wishlist-drawer__items"></ul>';
    cartBody.appendChild(wlSection);
    if (window.renderWishlistDrawer) window.renderWishlistDrawer();
  }

  function renderCart(cart) {
    /* update badge */
    document.querySelectorAll('#cart-count, .cart-badge').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('cart-badge--hidden', cart.item_count === 0);
    });

    /* empty state */
    if (cart.item_count === 0) {
      cartBody.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<svg viewBox="0 0 60 60" fill="none" width="60" height="60"><circle cx="30" cy="30" r="29" stroke="#C9A96E" stroke-width="0.8" stroke-dasharray="3 2" opacity="0.5"/><path d="M18 21h24l-3 15H21L18 21z" stroke="#C9A96E" stroke-width="1" stroke-linejoin="round"/><path d="M25 21c0-2.761 2.239-5 5-5s5 2.239 5 5" stroke="#C9A96E" stroke-width="1" stroke-linecap="round"/><circle cx="25" cy="38" r="1.5" fill="#C9A96E" opacity="0.6"/><circle cx="35" cy="38" r="1.5" fill="#C9A96E" opacity="0.6"/></svg>' +
        '<p class="cart-drawer__empty-title">' + window.MB_I18N.emptyTitle + '</p>' +
        '<p class="cart-drawer__empty-sub">' + window.MB_I18N.emptySub + '</p>' +
        '<a href="/collections" class="cart-drawer__empty-cta js-cart-drawer-close">' + window.MB_I18N.discover + '</a>' +
        '</div>';
      if (cartFoot) cartFoot.style.display = 'none';
      injectWishlistSection();
      return;
    }

    /* items */
    var html = '<ul class="cart-drawer__items">';
    cart.items.forEach(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/\.(jpg|jpeg|png|gif|webp)/, '_160x200_crop_center.$1') + '" alt="' + (item.title || '').replace(/"/g, '') + '" width="80" height="100" loading="lazy"/>'
        : '<div class="cart-drawer__item-img-placeholder"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="1"/></svg></div>';
      var type   = item.product_type ? '<p class="cart-drawer__item-type">' + item.product_type + '</p>' : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>' : '';
      var vol = (item.properties && item.properties._volume)
        ? '<p class="cart-drawer__item-vol">' + item.properties._volume + '</p>' : '';
      html +=
        '<li class="cart-drawer__item" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-drawer__item-img" tabindex="-1">' + img + '</a>' +
          '<div class="cart-drawer__item-info">' +
            type +
            '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
            variant + vol +
            '<div class="cart-drawer__item-row">' +
              '<div class="cart-drawer__qty">' +
                '<button type="button" class="cart-drawer__qty-btn" data-key="' + item.key + '" data-action="minus" aria-label="Diminuer">−</button>' +
                '<span class="cart-drawer__qty-val">' + item.quantity + '</span>' +
                '<button type="button" class="cart-drawer__qty-btn" data-key="' + item.key + '" data-action="plus" aria-label="Augmenter">+</button>' +
              '</div>' +
              '<span class="cart-drawer__item-price">' + fmt(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="cart-drawer__item-remove" data-key="' + item.key + '" aria-label="' + window.MB_I18N.remove + '">' + window.MB_I18N.remove + '</button>' +
          '</div>' +
        '</li>';
    });
    html += '</ul>';
    cartBody.innerHTML = html;
    injectWishlistSection();

    /* footer */
    if (cartFoot) {
      var threshold = 7500;
      var shipping;
      if (cart.total_price < threshold) {
        var pct = Math.min(100, Math.round(cart.total_price * 100 / threshold));
        shipping =
          '<div class="cart-drawer__shipping-bar"><div class="cart-drawer__shipping-fill" style="width:' + pct + '%"></div></div>' +
          '<p class="cart-drawer__shipping-text">' + window.MB_I18N.freeShipPre + '<strong>' + fmt(threshold - cart.total_price) + '</strong>' + window.MB_I18N.freeShipSuf + '</p>';
      } else {
        shipping =
          '<p class="cart-drawer__shipping-unlocked"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> ' + window.MB_I18N.freeShipUnlocked + '</p>';
      }
      cartFoot.innerHTML =
        shipping +
        '<div class="cart-drawer__subtotal"><span>' + window.MB_I18N.subtotal + '</span><span>' + fmt(cart.total_price) + '</span></div>' +
        '<p class="cart-drawer__shipping-note">' + window.MB_I18N.taxNote + '</p>' +
        '<a href="/cart" class="cart-drawer__checkout">' + window.MB_I18N.checkout + '</a>' +
        '<button type="button" class="cart-drawer__continue js-cart-drawer-close">' + window.MB_I18N.continueShopping + '</button>';
      cartFoot.style.display = '';
    }

    /* event delegation on body */
    cartBody.onclick = function (e) {
      var btn = e.target.closest('.cart-drawer__qty-btn');
      if (btn) {
        var li = btn.closest('.cart-drawer__item');
        var qtyEl = li && li.querySelector('.cart-drawer__qty-val');
        var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var next = btn.dataset.action === 'minus' ? Math.max(0, cur - 1) : cur + 1;
        changeItem(btn.dataset.key, next);
        return;
      }
      var rem = e.target.closest('.cart-drawer__item-remove');
      if (rem) { changeItem(rem.dataset.key, 0); return; }
      var cls = e.target.closest('.js-cart-drawer-close');
      if (cls) { closeCartDrawer(); }
    };
    if (cartFoot) {
      cartFoot.onclick = function (e) {
        if (e.target.closest('.js-cart-drawer-close')) closeCartDrawer();
      };
    }
  }

  function changeItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCart(cart); })
    .catch(function () {});
  }
})();
}); // end ready()

/* -- Password eye toggle --------------------------------------------------- */
document.querySelectorAll('.account-drawer__eye').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var input = document.getElementById(this.dataset.target);
    var isHidden = input.type === 'password';
    input.type = isHidden ? 'text' : 'password';
    this.querySelector('.eye-show').style.display = isHidden ? 'none' : '';
    this.querySelector('.eye-hide').style.display = isHidden ? '' : 'none';
    this.setAttribute('aria-label', isHidden ? 'Masquer le mot de passe' : 'Afficher le mot de passe');
    input.focus();
  });
});

/* ── Maison Bourgeois : header fixe condensé + reveal au défilement ──────── */
(function () {
  var header = document.querySelector('.site-header');

  /* 1) Header se condense au scroll */
  if (header) {
    var ticking = false;
    var headerScrolled = false;
    /* Hysteresis : on ajoute is-scrolled au-dela de 64px, on l'enleve sous 24px.
       Cette bande morte empeche le clignotement quand on se repose pres du haut. */
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var y = window.scrollY || window.pageYOffset || 0;
          if (!headerScrolled && y > 64) { headerScrolled = true; header.classList.add('is-scrolled'); }
          else if (headerScrolled && y < 24) { headerScrolled = false; header.classList.remove('is-scrolled'); }
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 2) Reveal des sections au défilement */
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced || !('IntersectionObserver' in window)) return;

  var selectors = [
    '.hero-content', '.section-title', '.section-header',
    '.product-card', '.collection-card', '.collection-card--large',
    '.editorial-inner', '.editorial-content', '.featured-collection',
    '.value-item', '.testimonial-card', '.rich-text', '.image-with-text',
    '.blog-card', '.product-gallery', '.product-info', '.newsletter', '.faq-item'
  ];
  var seen = [];
  var els = [];
  selectors.forEach(function (s) {
    document.querySelectorAll(s).forEach(function (el) {
      if (header && header.contains(el)) return;
      if (seen.indexOf(el) !== -1) return;
      seen.push(el); els.push(el);
    });
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('reveal-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  els.forEach(function (el, i) {
    el.classList.add('reveal-init');
    var mod = i % 3;
    if (mod === 1) el.classList.add('reveal-d1');
    else if (mod === 2) el.classList.add('reveal-d2');
    io.observe(el);
  });

  /* Failsafe : tout révéler après 1.6s si l'observer n'a pas agi (sécurité contenu) */
  window.setTimeout(function () {
    els.forEach(function (el) { el.classList.add('reveal-in'); });
  }, 1600);
})();


/* -- Maison Bourgeois : recherche deroulante + mini-panier au survol -- */
(function () {
  /* Recherche deroulante */
  var searchPanel = document.getElementById('header-search');
  var searchToggles = document.querySelectorAll('.js-search-toggle');
  if (searchPanel && searchToggles.length) {
    var searchInput = searchPanel.querySelector('.header-search__input');
    function openSearch() {
      searchPanel.classList.add('is-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      searchToggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      if (searchInput) setTimeout(function () { searchInput.focus(); }, 120);
    }
    function closeSearch() {
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchToggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
    searchToggles.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        searchPanel.classList.contains('is-open') ? closeSearch() : openSearch();
      });
    });
    var closeBtn = searchPanel.querySelector('.js-search-close');
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) closeSearch();
    });
    document.addEventListener('click', function (e) {
      if (!searchPanel.classList.contains('is-open')) return;
      if (searchPanel.contains(e.target)) return;
      if (e.target.closest('.js-search-toggle')) return;
      closeSearch();
    });
  }

  /* Mini-panier au survol (desktop uniquement) */
  var miniCart = document.getElementById('mini-cart');
  var cartIcon = document.querySelector('.nav-right .cart-icon');
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches && window.innerWidth > 768;
  if (miniCart && cartIcon && canHover) {
    var hideTimer = null;
    function fmt(c) {
      if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(c);
      return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    }
    function renderMini(cart) {
      if (!cart.items || cart.item_count === 0) {
        miniCart.innerHTML = '<div class="mini-cart__title">Votre panier</div><div class="mini-cart__empty">Votre panier est vide.</div>';
        return;
      }
      var h = '<div class="mini-cart__title">Votre panier &middot; ' + cart.item_count + '</div>';
      cart.items.slice(0, 4).forEach(function (it) {
        var img = it.image
          ? '<img class="mini-cart__img" src="' + it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_96x120_crop_center$1$2') + '" alt="" loading="lazy" />'
          : '<div class="mini-cart__img"></div>';
        h += '<div class="mini-cart__item">' + img +
             '<div class="mini-cart__info"><a class="mini-cart__name" href="' + it.url + '">' + it.product_title + '</a>' +
             '<div class="mini-cart__meta">Qte ' + it.quantity + '</div></div>' +
             '<div class="mini-cart__price">' + fmt(it.final_line_price) + '</div></div>';
      });
      if (cart.items.length > 4) h += '<div class="mini-cart__meta" style="text-align:center;margin-top:8px;">+ ' + (cart.items.length - 4) + ' autre(s)</div>';
      h += '<div class="mini-cart__foot"><div class="mini-cart__subtotal"><span>' + window.MB_I18N.subtotal + '</span><span>' + fmt(cart.total_price) + '</span></div>' +
           '<a class="mini-cart__checkout" href="/cart">Voir le panier</a></div>';
      miniCart.innerHTML = h;
    }
    function showMini() {
      clearTimeout(hideTimer);
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        renderMini(cart);
        miniCart.classList.add('is-open');
        miniCart.setAttribute('aria-hidden', 'false');
      }).catch(function () {});
    }
    function hideMini() {
      hideTimer = setTimeout(function () {
        miniCart.classList.remove('is-open');
        miniCart.setAttribute('aria-hidden', 'true');
      }, 260);
    }
    cartIcon.addEventListener('mouseenter', showMini);
    cartIcon.addEventListener('mouseleave', hideMini);
    cartIcon.addEventListener('click', function () { clearTimeout(hideTimer); miniCart.classList.remove('is-open'); });
    miniCart.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    miniCart.addEventListener('mouseleave', hideMini);
  }
})();

/* Selecteurs langue/devise (footer) : auto-submit au changement */
document.addEventListener("DOMContentLoaded",function(){document.querySelectorAll(".js-loc-select").forEach(function(sel){sel.addEventListener("change",function(){if(this.form)this.form.submit();});});});
